import {
  FETCH_SH_INIT,
  FETCH_SH_CLIENT_REQUEST,
  FETCH_SH_CLIENT_SUCCESS,
  FETCH_SH_CLIENT_FAILURE,
  FETCH_SH_STRIPE_CUSTOMERS_REQUEST,
  FETCH_SH_STRIPE_CUSTOMERS_SUCCESS,
  FETCH_SH_STRIPE_CUSTOMERS_FAILURE,
} from '../actions/types';

const initialState = {
  client: null,
  client_loading: false,
  stripe_customers: [],
  stripe_customers_loading: false,
};

// for one client
const ScheduleHelperReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SH_INIT:
      return initialState;
    case FETCH_SH_CLIENT_REQUEST:
      return { ...state, client: initialState.client, client_loading: true };
    case FETCH_SH_CLIENT_SUCCESS:
      return { ...state, client: action.payload, client_loading: false };
    case FETCH_SH_CLIENT_FAILURE:
      return { ...state, client: initialState.client, client_loading: false };
    case FETCH_SH_STRIPE_CUSTOMERS_REQUEST:
      return {
        ...state,
        stripe_customers: initialState.stripe_customers,
        stripe_customers_loading: true,
      };
    case FETCH_SH_STRIPE_CUSTOMERS_SUCCESS:
      return {
        ...state,
        stripe_customers: action.payload,
        stripe_customers_loading: false,
      };
    case FETCH_SH_STRIPE_CUSTOMERS_FAILURE:
      return {
        ...state,
        stripe_customers: initialState.stripe_customers,
        stripe_customers_loading: false,
      };
    default:
      return state;
  }
};

export default ScheduleHelperReducer;
